<template>
  <div
    :class="active?'active':'no-active'"
    class="card"
  >
    <div
      :style="`background-color:#${rgb};`"
      class="color-block"/>
    <div
      class="monji-block"
    >
      <div class="head">{{ head }}</div>
      <div class="title">{{ title }}</div>
      <div class="rgb">{{ '#'+rgb }}</div>
      <div class="css">
        <div class="rgbt r">R: {{ r }}&nbsp;</div>
        <div class="rgbt g">G: {{ g }}&nbsp;</div>
        <div class="rgbt b">B: {{ b }}</div>
      </div>
    </div>
  </div>
</template>

<script>

// import color from 'onecolor'

export default {
  props: {
    title: {
      type: String,
      default: '-',
    },
    head: {
      type: String,
      default: '-',
    },
    rgb: {
      type: String,
      default: '-',
    },
    r: {
      type: Number,
      default: 0,
    },
    g: {
      type: Number,
      default: 0,
    },
    b: {
      type: Number,
      default: 0,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleActive (e) {
      // console.log('event', e.target)
      let elements = document.querySelectorAll('.card')
      Array.prototype.forEach.call(elements, function (el, i) {
        el.classList.remove('active')
      })
      e.target.parentNode.parentNode.classList.add('active')
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/mixin.scss';
.card {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #3a3226;
  height: 2.5rem;
  cursor: pointer;
  .css {
    font-size: .5em;
    opacity: .72;
    display: none;
  }
  .rgb {
    font-size: .5em;
    display: inline-flex;
  }
  .color-block {
    height: 100%;
    width: 0.5rem;
    margin-right: 0.5rem;
    flex-grow: 0;
    transition: width .33s .1s ease-in-out;
    .rgbt {
      opacity: 0;
      display: inline-flex;
    }
  }
  .monji-block {
    flex-grow: 0;
    flex-shrink: 1;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .head {
      //font-family: 'XANO';
      width: 100%;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: .66rem;
    }
    .title {
      //font-family: 'XANO';
      width: 100%;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: .8rem;
    }
    .rgb {
      opacity: .66;
    }
  }
  &.active {
    background: #3a3226;
    color: white;
    transition: all 1s ease-in-out;
    @include for-tablet-up {
      .monji-block {
        flex-direction: row;
        justify-content: baseline;
        .head {
          width: 4rem;
          font-size: 1.2rem;
          color: lightgrey;
        }
        .title {
          font-size: 1.2rem;
        }
        .rgb {
          font-size: 1.2rem;
          opacity: .8;
          padding-right: .5rem;
        }
      }
    }
    &:hover {
      .rgb {
        display: inline-flex;
      }
      .css {
        display: none;
      }
    }
  }
  &.active {
    .rgb {
      display: inline-flex;
    }
    .css {
      display: none;
    }
  }
  &:hover {
    .rgb {
      display: none;
    }
    .css {
      display: inline-flex;
    }
    .color-block {
      flex-grow: 1;
      width: .5rem;
    }
  }
}
</style>
